
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91id_93fELTs6bVGBtOXiqQKizz0iKT9sC1Xr_GDs5WaqiifVwMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/account/orders/[id].vue?macro=true";
import { default as _91id_93eqGvgkQFnzQjPmYG12pP_OWqkBLpms6BeOqfXdLo1sIMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/account/returns/[id].vue?macro=true";
import { default as addressesudJKJCPJrZMEu3yTUCUFDw_BRifpj_XOnogm1ObvBYgMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/account/addresses.vue?macro=true";
import { default as affiliateCre098OmR_NkXVIMKqT_nVef4YRgkswkBKAIQ_9El7sMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/account/affiliate.vue?macro=true";
import { default as billingoNuC2kM54BA6jaDMhRuOpzhQR60i9yk56mX_aaCRy4gMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/account/billing.vue?macro=true";
import { default as notificationsUNOYTluaO_ywBTBpilCWSYoEhlekuuTFaNhVhMPp59kMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/account/notifications.vue?macro=true";
import { default as indexH5oJc6g45zB6r9lkq6jxDxpHiKnhjF5dNaX8HNa5DuoMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/account/orders/index.vue?macro=true";
import { default as profilekRTWbL862ok_iBNBceLj6T0ivoKpvOvevsZn0K5pIVIMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/account/profile.vue?macro=true";
import { default as indexdvpdmnzJufKkhEoA2d2fd3gGnD__E0T7AjxZj00CpXwMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/account/returns/index.vue?macro=true";
import { default as trackingsNL750I8KoSU_TIjGJIK2zL4ShHcKKRZLYBXJp3iHFcMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/account/tracking.vue?macro=true";
import { default as reset_45password3JoAm1OfWGB2DNYE2wRLWBcO_jOlz6Lf_WOPwWRdNK0Meta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/auth/reset-password.vue?macro=true";
import { default as social_45consentw4ECBJJHOpOKiTM2isKEStWp9ZdBQDoWvPgQ5nHJ6_YMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/auth/social-consent.vue?macro=true";
import { default as _91id_slug_93EfOOY677LGmXR4jzlO85dS9qKdbmbcH4zKW4AHtyy_UMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/marka/[id_slug].vue?macro=true";
import { default as _91slug_93RYcX44SJXKQ_jFyAFBYc3jd5409zEiZC5ygafIZcjy4Meta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/products/[slug].vue?macro=true";
import { default as _91id_93gPpW__oncJAPtMCgqh8K91CcWb5aQFZCP6eXHBcFWlsMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/zamowienie/[id].vue?macro=true";
import { default as aboutfYXRPgQEw_3Xvi5o3Xyka3CcqRW8M8mQDnC7KeEePz0Meta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/about.vue?macro=true";
import { default as indexFhhIHaSrKuYqurKQScfcWVFaA0mY3l1M16f_55L9_A8Meta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/account/index.vue?macro=true";
import { default as indexTLNzFy5vUcWv_tHIPhbBJ80kcd4PFKaSH7Crj5jqurIMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/auth/index.vue?macro=true";
import { default as cartVY9MA1__8gl0UerVi1F6i73syN9EBa39_0QUKgc2fWoMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/cart.vue?macro=true";
import { default as cart_45recoverbN38jvAeYpbdS3LOnRD5cbJ9j2_J25XWGD9yJUB0qk4Meta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/cart-recover.vue?macro=true";
import { default as cod_45successqRNcyX0dEUnr63O6RD5hnDTLHJAxSE3n5_DNUQ22DxEMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/checkout/cod-success.vue?macro=true";
import { default as statusN_A6OZBTZiXpeLttmVX0G9GrjwcXQ538cfjH9Vig_zEMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/checkout/status.vue?macro=true";
import { default as checkout97naqGs1Lwbhho3YcXEzqMguts82xzIa6LS5qD19f0UMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/checkout.vue?macro=true";
import { default as contactnY1LqncCDZGVNycPm9RsWHr7oBrfXDcut2KNfoUTNN8Meta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/contact.vue?macro=true";
import { default as favoritesgShWFePXhqiwBVtN27pZNGSopCK_GiR5_30lxnfctw4Meta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/favorites.vue?macro=true";
import { default as lista_45zapytaniaIO4uhwxfW1f_JIWuKA7xbtTUAcinsUqWAeuKzK4C_hMMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/lista-zapytania.vue?macro=true";
import { default as markibgdXP9fhczLv_B4nqwH2TFrrjh1Bb9jd4jdvHVdoquoMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/marki.vue?macro=true";
import { default as newsletterqFJbLqsB64S_AIRuXtSZ_N2wMpTax88baUjCiZlHKuwMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/newsletter.vue?macro=true";
import { default as nowosciNPsTAedBWdctsCQn2kuKfxWegW8Ioabdl1pMT8M3enYMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/nowosci.vue?macro=true";
import { default as offlinepTybclgsQ6Gt6_c0GdLd8PACZTlR1GanSQOeEskZDLsMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/offline.vue?macro=true";
import { default as polityka_45prywatnosci0uV99H7GvIdgMJctEfPEc0TVQ2Xx6YMbAaIrhTnKcuMMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/polityka-prywatnosci.vue?macro=true";
import { default as regulamin_45sklepue61O89oVW_sVSm9HwJOCW0zugKTlniifpMdqGnOW8fIMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/regulamin-sklepu.vue?macro=true";
import { default as searchum0jbXq_JKglyvrs5lmRI_KyVhq8W9mYSc_wJ4ODh18Meta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/search.vue?macro=true";
import { default as segmentify_45searchF7SFm9pQReagD_8PKJFHFEOnEDPxsqQ1vQc19zdft_cMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/segmentify-search.vue?macro=true";
import { default as sledzenie_45zamowieniayB_0_99zgpZyQqh6EG__wttN8kJPe6e_WDfrhbn_CE0Meta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/sledzenie-zamowienia.vue?macro=true";
import { default as tabele_45rozmiarowmfrzqQdTL50HLXNBip1N8ePFbnbpJDSdwVp_EYkqYk0Meta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/tabele-rozmiarow.vue?macro=true";
import { default as techniki_45znakowaniaUKjO5Q72qrpbZqPhn1Y_OZI890l8l17zgz5xCjox_NUMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/techniki-znakowania.vue?macro=true";
import { default as thank_45youDADBA_9tr8_b1QQweU2SlXKfjt1ocopfjdhmOdjrpjMMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/thank-you.vue?macro=true";
import { default as zwrotyMllIUYsORqHgLWumCE5rn51EtnBo4khHqCb5F_ePuZ8Meta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/zwroty.vue?macro=true";
import { default as _91_46_46_46slug_93BLqokdNqACcewCLUTGxm6FwBvGy8mau9gERvCTM5t10Meta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/[...slug].vue?macro=true";
import { default as index0sbDleAJ7nP_eFr5wp1bsgdOBakQ1Ezdn6qDy0JFH6QMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/index.vue?macro=true";
import { default as component_45stub5AXxRhqD1sLNptntDQJalT3zErO3xD5VonQ7jBntc2kMeta } from "/builds/contelizer-easyitem-com/prestashop-rest-front/node_modules/.pnpm/nuxt@4.4.2_@babel+core@7.29.0_@babel+plugin-syntax-jsx@7.28.6_@babel+core@7.29.0__@emna_67be9d6c4fec2b344def8eb49743e987/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub5AXxRhqD1sLNptntDQJalT3zErO3xD5VonQ7jBntc2k } from "/builds/contelizer-easyitem-com/prestashop-rest-front/node_modules/.pnpm/nuxt@4.4.2_@babel+core@7.29.0_@babel+plugin-syntax-jsx@7.28.6_@babel+core@7.29.0__@emna_67be9d6c4fec2b344def8eb49743e987/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "account-orders-id",
    path: "/account/orders/:id()",
    meta: {"middleware":"auth"},
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/account/orders/[id].vue")
  },
  {
    name: "account-returns-id",
    path: "/account/returns/:id()",
    meta: {"middleware":"auth"},
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/account/returns/[id].vue")
  },
  {
    name: "account-addresses",
    path: "/account/addresses",
    meta: {"middleware":"auth"},
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/account/addresses.vue")
  },
  {
    name: "account-affiliate",
    path: "/account/affiliate",
    meta: {"middleware":"auth"},
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/account/affiliate.vue")
  },
  {
    name: "account-billing",
    path: "/account/billing",
    meta: {"middleware":"auth"},
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/account/billing.vue")
  },
  {
    name: "account-notifications",
    path: "/account/notifications",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/account/notifications.vue")
  },
  {
    name: "account-orders",
    path: "/account/orders",
    meta: {"middleware":"auth"},
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/account/orders/index.vue")
  },
  {
    name: "account-profile",
    path: "/account/profile",
    meta: {"middleware":"auth"},
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/account/profile.vue")
  },
  {
    name: "account-returns",
    path: "/account/returns",
    meta: {"middleware":"auth"},
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/account/returns/index.vue")
  },
  {
    name: "account-tracking",
    path: "/account/tracking",
    meta: {"middleware":"auth"},
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/account/tracking.vue")
  },
  {
    name: "auth-reset-password",
    path: "/auth/reset-password",
    meta: {"middleware":"guest-only"},
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/auth/reset-password.vue")
  },
  {
    name: "auth-social-consent",
    path: "/auth/social-consent",
    meta: {"middleware":"guest-only"},
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/auth/social-consent.vue")
  },
  {
    name: "marka-id_slug",
    path: "/marka/:id_slug()",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/marka/[id_slug].vue")
  },
  {
    name: "products-slug",
    path: "/products/:slug()",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/products/[slug].vue")
  },
  {
    name: "zamowienie-id",
    path: "/zamowienie/:id()",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/zamowienie/[id].vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/about.vue")
  },
  {
    name: "account",
    path: "/account",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/account/index.vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: {"middleware":"guest-only"},
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/auth/index.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/cart.vue")
  },
  {
    name: "cart-recover",
    path: "/cart-recover",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/cart-recover.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/checkout.vue"),
    children: [
  {
    name: "checkout-cod-success",
    path: "cod-success",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/checkout/cod-success.vue")
  },
  {
    name: "checkout-status",
    path: "status",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/checkout/status.vue")
  }
]
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/contact.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/favorites.vue")
  },
  {
    name: "lista-zapytania",
    path: "/lista-zapytania",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/lista-zapytania.vue")
  },
  {
    name: "marki",
    path: "/marki",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/marki.vue")
  },
  {
    name: "newsletter",
    path: "/newsletter",
    meta: newsletterqFJbLqsB64S_AIRuXtSZ_N2wMpTax88baUjCiZlHKuwMeta || {},
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/newsletter.vue")
  },
  {
    name: "nowosci",
    path: "/nowosci",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/nowosci.vue")
  },
  {
    name: "offline",
    path: "/offline",
    meta: offlinepTybclgsQ6Gt6_c0GdLd8PACZTlR1GanSQOeEskZDLsMeta || {},
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/offline.vue")
  },
  {
    name: "polityka-prywatnosci",
    path: "/polityka-prywatnosci",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/polityka-prywatnosci.vue")
  },
  {
    name: "regulamin-sklepu",
    path: "/regulamin-sklepu",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/regulamin-sklepu.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/search.vue")
  },
  {
    name: "segmentify-search",
    path: "/segmentify-search",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/segmentify-search.vue")
  },
  {
    name: "sledzenie-zamowienia",
    path: "/sledzenie-zamowienia",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/sledzenie-zamowienia.vue")
  },
  {
    name: "tabele-rozmiarow",
    path: "/tabele-rozmiarow",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/tabele-rozmiarow.vue")
  },
  {
    name: "techniki-znakowania",
    path: "/techniki-znakowania",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/techniki-znakowania.vue")
  },
  {
    name: "thank-you",
    path: "/thank-you",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/thank-you.vue")
  },
  {
    name: "zwroty",
    path: "/zwroty",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/zwroty.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/[...slug].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/pages/index.vue")
  },
  {
    name: component_45stub5AXxRhqD1sLNptntDQJalT3zErO3xD5VonQ7jBntc2kMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub5AXxRhqD1sLNptntDQJalT3zErO3xD5VonQ7jBntc2k
  },
  {
    name: component_45stub5AXxRhqD1sLNptntDQJalT3zErO3xD5VonQ7jBntc2kMeta?.name,
    path: "/brands",
    component: component_45stub5AXxRhqD1sLNptntDQJalT3zErO3xD5VonQ7jBntc2k
  },
  {
    name: component_45stub5AXxRhqD1sLNptntDQJalT3zErO3xD5VonQ7jBntc2kMeta?.name,
    path: "/kontakt",
    component: component_45stub5AXxRhqD1sLNptntDQJalT3zErO3xD5VonQ7jBntc2k
  },
  {
    name: component_45stub5AXxRhqD1sLNptntDQJalT3zErO3xD5VonQ7jBntc2kMeta?.name,
    path: "/content/4-o-nas",
    component: component_45stub5AXxRhqD1sLNptntDQJalT3zErO3xD5VonQ7jBntc2k
  },
  {
    name: component_45stub5AXxRhqD1sLNptntDQJalT3zErO3xD5VonQ7jBntc2kMeta?.name,
    path: "/nowe-produkty",
    component: component_45stub5AXxRhqD1sLNptntDQJalT3zErO3xD5VonQ7jBntc2k
  },
  {
    name: component_45stub5AXxRhqD1sLNptntDQJalT3zErO3xD5VonQ7jBntc2kMeta?.name,
    path: "/content/2-polityka-prywatnosci",
    component: component_45stub5AXxRhqD1sLNptntDQJalT3zErO3xD5VonQ7jBntc2k
  },
  {
    name: component_45stub5AXxRhqD1sLNptntDQJalT3zErO3xD5VonQ7jBntc2kMeta?.name,
    path: "/content/3-regulamin-sklepu",
    component: component_45stub5AXxRhqD1sLNptntDQJalT3zErO3xD5VonQ7jBntc2k
  },
  {
    name: component_45stub5AXxRhqD1sLNptntDQJalT3zErO3xD5VonQ7jBntc2kMeta?.name,
    path: "/content/6-bezpieczenstwo-produktu",
    component: component_45stub5AXxRhqD1sLNptntDQJalT3zErO3xD5VonQ7jBntc2k
  }
]